import { Alert, Box } from "@mui/material"

export default function SecurityPriceErrorFallback() {
  return (
    <Box sx={{ p: 2 }}>
      <Alert severity="error">
        Unable to load intraday price data.
      </Alert>
    </Box>
  )
}
